var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["progress", _vm.size ? "progress-" + _vm.size : ""],
      attrs: { id: _vm.progressId }
    },
    [
      _c("div", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.top-center",
            value: {
              content: _vm.$t("MAIN_CONTENT.ProgressBar.completed", {
                percent: _vm.percent.COMPLETED
              }),
              trigger: "hover click"
            },
            expression:
              "{content: $t('MAIN_CONTENT.ProgressBar.completed', { percent: percent.COMPLETED } ), trigger: 'hover click'}",
            modifiers: { "top-center": true }
          }
        ],
        staticClass: "progress-bar completed-progress-bar",
        style: { width: _vm.percent.COMPLETED + "%" },
        attrs: {
          role: "progressbar",
          id: "completed_" + _vm.id,
          "aria-valuenow": _vm.percent.COMPLETED,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.top-center",
            value: {
              content: _vm.$t("MAIN_CONTENT.ProgressBar.inProgress", {
                percent: _vm.percent.IN_PROGRESS
              }),
              trigger: "hover click"
            },
            expression:
              "{content: $t('MAIN_CONTENT.ProgressBar.inProgress', { percent: percent.IN_PROGRESS } ), trigger: 'hover click'}",
            modifiers: { "top-center": true }
          }
        ],
        staticClass: "progress-bar in-progress-background",
        style: { width: _vm.percent.IN_PROGRESS + "%" },
        attrs: {
          role: "progressbar",
          id: "inProgress_" + _vm.id,
          "aria-valuenow": _vm.percent.IN_PROGRESS,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }